import getLang from 'I18n/utils/getLang';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { mapAppliedFiltersForRpc } from '../../search-results/utils/searchMappers';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';

/**
 * Hook to fetch 6 apps from the most recent published collection
 */
export function useCollectionApps(featuredCollectionId) {
  var _appsQuery$data, _recentCollection$pub, _recentCollection$pub2, _recentCollection$pub3, _recentCollection$pub4;
  const collectionResult = useCollectionQuery(featuredCollectionId ? {
    mode: 'id',
    collectionId: featuredCollectionId
  } : {
    mode: 'recent'
  });
  const recentCollection = collectionResult.isUmbrellaCollection ? undefined : collectionResult.data;
  const appsQuery = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      skip: !(recentCollection !== null && recentCollection !== void 0 && recentCollection.id),
      variables: {
        queryType: 'ELASTIC_SEARCH',
        language: getLang(),
        collectionId: recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.id,
        offset: 0,
        length: 6,
        filter: mapAppliedFiltersForRpc([{
          field: 'PRODUCT_TYPE',
          dataType: 'STRING',
          values: ['APP']
        }])
      }
    }
  });
  const cards = ((_appsQuery$data = appsQuery.data) === null || _appsQuery$data === void 0 ? void 0 : _appsQuery$data.result.cards) || [];
  const hasValidCollectionData = !!(recentCollection !== null && recentCollection !== void 0 && recentCollection.id && cards.length > 0);
  return {
    cards,
    collectionId: (recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.id) || 0,
    collectionSlug: (recentCollection === null || recentCollection === void 0 || (_recentCollection$pub = recentCollection.publishedListing) === null || _recentCollection$pub === void 0 ? void 0 : _recentCollection$pub.slug) || '',
    description: (recentCollection === null || recentCollection === void 0 || (_recentCollection$pub2 = recentCollection.publishedListing) === null || _recentCollection$pub2 === void 0 ? void 0 : _recentCollection$pub2.description) || '',
    error: appsQuery.error,
    hasValidCollectionData,
    loading: appsQuery.loading,
    title: (recentCollection === null || recentCollection === void 0 || (_recentCollection$pub3 = recentCollection.publishedListing) === null || _recentCollection$pub3 === void 0 ? void 0 : _recentCollection$pub3.title) || (recentCollection === null || recentCollection === void 0 || (_recentCollection$pub4 = recentCollection.publishedListing) === null || _recentCollection$pub4 === void 0 ? void 0 : _recentCollection$pub4.name) || ''
  };
}